<div [ngClass]="{ 'incentive-quest-body': incentiveQuests.length === 0 }">
    <p-dialog [(visible)]="showIncentivePopUp" [modal]="true" [style]="{width: '724px', height: '500px'}"
              [draggable]="false" [resizable]="false" (onHide)="hideIncentiveQuestPopup()">
        <ng-template pTemplate="header">Create Incentive Quest</ng-template>
        <div style="display: flex; flex-direction: column; align-items: center;">
            <div style=" width: 100%" class="flex flex-row">
                <div class="col-12 p-2">
                    <div class="new-quest-header-label">Quest Details</div>
                </div>
            </div>

            <div style=" width: 100%" class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-quest-label">Quest Name</div>
                    <input type="text" [(ngModel)]="incentiveModel.QuestName" name="QuestName" required placeholder="Enter Quest Name" pInputText />
                    <div class="err mt-1" id="questNameErr">This field is required</div>
                </div>
                <div class="col-6 p-2">
                    <div class="new-quest-label">Participant</div>
                    <p-dropdown [options]="participantTypes" placeholder="Select Participant"
                                optionLabel="name" [(ngModel)]="incentiveModel.Participant"></p-dropdown>
                    <div class="err mt-1" id="participantErr">This field is required</div>
                </div>
            </div>

            <div style=" width: 100%" class="flex flex-row">
                <div class="col-6 p-2">
                    <div class="new-quest-label">Duration</div>
                    <p-calendar [(ngModel)]="incentiveModel.QuestStarts" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Select Start Date"></p-calendar>
                    <div class="err mt-1" id="questStartsErr">This field is required</div>
                </div>
                <div class="col-6 p-2">
                    <div class="new-quest-label"> </div>
                    <p-calendar [(ngModel)]="incentiveModel.QuestEnds" dateFormat="mm-dd-yy"
                                inputId="dateformat"
                                placeholder="Select End Date"></p-calendar>
                    <div class="err mt-1" id="questEndsErr">This field is required</div>
                </div>
            </div>

            <div style=" width: 100%" class="flex flex-row">
                <div class="col-12 p-2">
                    <div class="new-quest-label">Description (Optional)</div>
                    <textarea style="resize: none; height: 150px;" [(ngModel)]="incentiveModel.Description" name="Description" placeholder="Enter Quest Description" pInputText></textarea>
                </div>
            </div>
        </div>
        <ng-template pTemplate="footer">
            <div class="flex justify-content-end" style="padding-right: 8px; padding-bottom: 0px; margin-bottom: 0px;">
                <div class="btn-close" (click)="hideIncentiveQuestPopup()">Cancel</div>
                <div class="btn-darkblue ml-3" (click)="createLoyaltyIncentive()">Create</div>
            </div>
        </ng-template>
    </p-dialog>

    <div *ngIf="incentiveQuests.length > 0 && selectedIncentiveModel === null">
        <div class="loyalty-header">
            <div class="onboarding-head-title">
                Driver Quests
            </div>
            <div style="display: flex; margin-left: auto; margin-top: 5px;">
                <input pInputText class="loyalty-search-input" [(ngModel)]="filter.searchName" (ngModelChange)="onChangeFilter()" placeholder="Search" />
                <button class="p-element btn-darkblue p-button p-component with-entries-btn-add-incentive-quest" (click)="openCreateIncentiveQuest()">Create Incentive Quest +</button>
            </div>
        </div>

        <div class="onboarding-head-fleft mr-3 mb-3">
            <ol class="breadcrumb-body breadcrumbs-menu loyalty-breadcrumbs">
                <ng-container *ngFor="let item of loyaltyStatusTypes">
                    <li class="breadcrumbs-menu-item"
                        [class]="(item.value === selectedLoyaltyStatusType) ? 'breadcrumbs-menu-active' : ''"
                        (click)="clickChangeMenuHomeActive(item.value)">{{item.name}}</li>
                </ng-container>
            </ol>
        </div>

        <section class="dashboard-section-flex">
            <div class="dashboard-col-md-4 loyalty-dashboard-card-container" *ngFor="let item of incentiveQuests">
                <div class="loyalty-dashboard-card" [attr.quest-id]="item.QuestId">
                    <div class="loyalty-dashboard-card-header" (click)="onCardClick(item)">
                        <div class="loyalty-dashboard-card-title" title="{{item.QuestName}}">{{item.QuestName}}</div>
                    </div>
                    <div class="loyalty-dashboard-card-status-container">
                        <div class="loyalty-dashboard-card-status loyalty-active" *ngIf="item.Status === 1">Active</div>
                        <div class="loyalty-dashboard-card-status loyalty-upcoming" *ngIf="item.Status === 2">Upcoming</div>
                        <div class="loyalty-dashboard-card-status loyalty-draft" *ngIf="item.Status === 3">Draft</div>
                        <div class="loyalty-dashboard-card-status loyalty-disabled" *ngIf="item.Status === 4">Deactivated</div>
                        <div class="loyalty-dashboard-card-status loyalty-ended" *ngIf="item.Status === 5">Quest Ended</div>
                    </div>
                    <div class="loyalty-dashboard-card-description-label-container">
                        Description
                    </div>
                    <div title="{{item.Description}}" class="loyalty-dashboard-card-description">
                        {{item.Description}}
                    </div>
                    <div class="loyalty-dashboard-card-duration-label-container">
                        Duration
                    </div>
                    <div class="loyalty-dashboard-card-duration">
                        {{item.QuestStarts}} to {{item.QuestEnds}}
                    </div>
                </div>
            </div>
        </section>
    </div>

    <div class="noIncentiveQuestContainer" *ngIf="incentiveQuests.length === 0">
        <div>
            <img class="no-entries-image-incentive-quest" src="Content/xpress-app/images/noIncentiveQuests.png" alt=''>
            <button type="button" class="p-element btn-darkblue p-button p-component no-entries-btn-add-incentive-quest" (click)="openCreateIncentiveQuest()">Create Incentive Quest +</button>
        </div>
    </div>

    <incentive-edit-component *ngIf="selectedIncentiveModel" (onBackLinkClick)="onBackLinkClick()" [incentiveModelInput]="incentiveModel"></incentive-edit-component>
</div>